"use strict";

import React from "react";
import Raphael from "raphael";
import ColorPickerDot from "../color-picker/ColorPickerDot";

class NumericalColorPickerComponent extends React.Component {
    // Get category color to display along with the checklist of category
    getColorHex = () => {
        let Dyn = this.props.Dyn;
        var colorString = Dyn.colorUtil.calcContinuousColor(
            this.props.attributeObj.statsPreFilter,
            this.props.attributeObj.color,
            this.props.attributeObj.stats.max,
            false
        ).colorString;
        return Raphael.getRGB(colorString).hex;
    };

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc(str);
    };

    render = () => {
        let Dyn = this.props.Dyn;

        return (
            <div
                className={
                    "tde-row tde-numerical-color-component tde-mt-3 tde-mb-2 tde-d-flex tde-flex-items-center" +
                    (this.props.reduceCaseCardWidth ? " tde-px-2" : " tde-px-3")
                }
            >
                <div className="tde-s1 tde-font-weight-bold tde-attr-name">
                    {this.getLoc("Colors")}
                </div>
                <div className="tde-input-legend  tde-ml-2 tde-mb-0">
                    <ColorPickerDot
                        color={this.getColorHex()}
                        colorsArray={Dyn.colorUtil.numericalColorOptions}
                        onChange={(color) => {
                            this.setState({ color: color.hex });
                            this.props.attributeObj.setFixedAttributeColorByColorString(
                                color.hex
                            );
                            // To refresh the plot upon save
                            if (Dyn.plotView) {
                                Dyn.plotView.refresh({
                                    action: "setDataColor",
                                });
                            }
                        }}
                        Dyn={Dyn}
                    />
                </div>
            </div>
        );
    };
}

export default NumericalColorPickerComponent;
